import script from "./LoginPageAd.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginPageAd.vue?vue&type=script&setup=true&lang=js"

import "./LoginPageAd.vue?vue&type=style&index=0&id=5d675ee0&scoped=true&lang=css"

import exportComponent from "D:\\cwzl\\cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d675ee0"]])

export default __exports__